// Generated by Claude Code
import type { ReactNode } from 'react'
import { Navigate, useLocation, useRouter } from '@tanstack/react-router'
import User from '#core/entities/auth/users/User.ts'
import { useUserState } from '#core/state/UserState.ts'
import { companyScopedPath, resolveCompanyLessAddress } from '#core/navigation/company-scoped-path.ts'
import { CompanyUnlockScreen } from '#components/entities/users/company-lock/company-unlock-screen.tsx'
import { CompanySelectLanding } from './company-select-landing.tsx'

/**
 * Completes an address that leaves the company out (`/analytics/work-orders`, as sent in a newsletter):
 * a single-company user goes straight to that page in their company (or its unlock screen when this
 * login cannot open it), a multi-company user picks the company first. Renders `fallback` when the
 * address is not a company page. Expects a signed-in user.
 */
export function CompanyLessPath({ fallback }: { fallback: ReactNode }) {
  const router = useRouter()
  const address = resolveCompanyLessAddress(useLocation().pathname)
  const companies = User.memberCompanies(useUserState().user)
  const target = companies.length > 0 ? companyScopedPath(router, companies[0].segment, address.pathname) : null

  if (!target) return fallback
  if (companies.length === 1 && companies[0].lockReasons.length > 0) return <CompanyUnlockScreen companyId={companies[0].id} />
  if (companies.length === 1) return <Navigate to={target} search={address.search ?? true} hash={true} replace />
  return <CompanySelectLanding path={address.pathname.replace(/^\/+/, '')} search={address.search} />
}
